import React from 'react'
import { v4 as uuidv4 } from 'uuid'
import { StyledChatBotScreen, StyledChatAndHistoryContainer } from './styled'
import ChatConversationSection from './ChatConversationSection'
import { useTheme } from '@mui/material/styles'
import { useMediaQuery } from '@mui/material'
import { getIsIframe } from '../../utils/getIsIframe'
import getForcedMobile from '../../utils/forceMobile'
import { useAppSelector, useAppDispatch } from '../../reducers/hooks'
import { userReducer } from '../../reducers/user/userReducer'
import ChatHistoryLayout from '../ChatHistory'

const ChatBotScreen: React.FC = (): JSX.Element => {
  const theme = useTheme()
  const dispatch = useAppDispatch()
  const forcedMobile = getForcedMobile()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isIframe = getIsIframe()
  const sessionId = useAppSelector((state) => state.user.sessionId)

  const handleStartNewChat = (): void => {
    dispatch(userReducer.actions.changeSessionId(`${uuidv4()}`))
  }

  return (
    <StyledChatBotScreen isMobile={isMobile || forcedMobile} isIframe={isIframe}>
      <StyledChatAndHistoryContainer>
        <ChatHistoryLayout />
        <ChatConversationSection session={sessionId} onOpenNewChat={handleStartNewChat}/>
      </StyledChatAndHistoryContainer>
    </StyledChatBotScreen>
  )
}

export default ChatBotScreen
